import config from '@/config'
import { createApi } from '@utils/api'

const api = createApi(`${config.parseApiBaseUrl}/api/v1`)

export default api

export const getStats = async () => api.get('/admin/stats')
